

































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { FormInput, FormDate, FormTextarea } from "../../parts";

interface Experience {
    company: string;
    job_title: string;
    job_description: string;
    tasks: string;
    date_from: string;
    date_to: string;
}

@Component({
    components: {
        FormInput,
        FormDate,
        FormTextarea
    }
})
export default class FromJobToolzExperience extends Vue {
    @Prop({ default: () => [] }) readonly value!: Experience[];

    @Prop() placeholder?: string;

    localValue: Experience[] = [];

    addNew() {
        this.localValue.push({
            company: "",
            job_title: "",
            job_description: "",
            tasks: "",
            date_from: "",
            date_to: ""
        });
    }

    remove(index: number) {
        this.localValue.splice(index, 1);
    }

    @Watch("value", { immediate: true })
    handleValueChange(value: Experience[]) {
        this.localValue = value;
    }

    @Watch("localValue")
    handleLocalValueChange(value: Experience[]) {
        this.$emit("input", value);
    }
}
